import "@fontsource/poppins";
import "@fontsource/poppins/100.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";
import {loadableReady} from '@loadable/component';
import { createRoot ,hydrateRoot} from 'react-dom/client';

import { addAdsense } from "@config/configAdsense/configAdsense";

import WrapRootElement from "./src/components/WrapRootElement";
import { initializeAndTrack } from './src/config/configCookies';
import { initializeAndAddFacebookSDK } from './src/config/configFbSDK'
import "./src/styles/globals.css";

import type { WindowLocation } from "@reach/router";


export const onRouteUpdate = ({ location }: { location: WindowLocation }) => {
  /** @cookie strict, always trigger */
  document.cookie = 'x-gdpr-track-always=true';
  initializeAndTrack(location)
}

export const onClientEntry = () => {
  addAdsense();
  initializeAndAddFacebookSDK();
}

export const wrapRootElement = WrapRootElement;

export const replaceHydrateFunction =  (_:any, options: any) => 
  (element: any, container: any) => {
  loadableReady(() => {
    const createRootFn =
      typeof options.useHydrate === "undefined"
        ? 
        process.env.BUILD_STAGE && process.env.BUILD_STAGE.includes("develop")
          ? createRoot
          : hydrateRoot
        : options.useHydrate
        ? hydrateRoot
        : createRoot

        const root = createRootFn(container,{} as any )

        root.render(element)

  })
}